import React from 'react';

import {
  CaptionText,
  FlexColumn,
  formatBigNumbers,
  formatNumber,
} from '@make-software/cspr-ui';
import { currencyPrecisionByCase, PrecisionCase } from '../../utils/currency';

export interface Cep18Props {
  amount?: string | null;
  totalSupply?: string | null;
  symbol?: string | null;
  precisionCase?: PrecisionCase;
  showFiatValue?: boolean;
}

export function Cep18FormattedAmount({
  amount,
  symbol,
  precisionCase,
  showFiatValue = true,
}: Cep18Props) {
  const precision = currencyPrecisionByCase(precisionCase);

  if (!amount) {
    return <>{'-'}</>;
  }

  const formattedCep18Amount = amount
    ? formatNumber(amount, {
        precision: precision,
      })
    : '-';

  const cep18Amount =
    formattedCep18Amount.length > 7
      ? formatBigNumbers(amount)
      : formattedCep18Amount;

  return (
    <FlexColumn>
      <>
        {cep18Amount} {symbol}
      </>
      {showFiatValue && (
        <CaptionText size={2} variation="darkGray">
          -
        </CaptionText>
      )}
    </FlexColumn>
  );
}

export default Cep18FormattedAmount;
